var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.3202,
    cy: 28.4984,
    r: 28.16,
    fill: "#050505"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1625 27.7987C36.9079 27.7987 36.6637 27.8998 36.4837 28.0799C36.3037 28.2599 36.2025 28.5041 36.2025 28.7587V34.9987L20.2185 19.0147C20.1293 18.9247 20.0231 18.8533 19.9061 18.8045C19.7891 18.7558 19.6637 18.7307 19.5369 18.7307C19.4102 18.7307 19.2847 18.7558 19.1677 18.8045C19.0508 18.8533 18.9446 18.9247 18.8553 19.0147C18.6765 19.1945 18.5762 19.4379 18.5762 19.6915C18.5762 19.9451 18.6765 20.1884 18.8553 20.3683L34.8201 36.3331H28.6185C28.3639 36.3331 28.1197 36.4342 27.9397 36.6143C27.7597 36.7943 27.6585 37.0385 27.6585 37.2931C27.6585 37.5477 27.7597 37.7919 27.9397 37.9719C28.1197 38.1519 28.3639 38.2531 28.6185 38.2531H37.2585C37.4877 38.2531 37.7074 38.1621 37.8695 38C38.0315 37.838 38.1225 37.6182 38.1225 37.3891V28.7491C38.12 28.4961 38.0177 28.2544 37.838 28.0765C37.6582 27.8985 37.4155 27.7987 37.1625 27.7987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.1aa4c8edc56434b99c60f6de41ff5e2e.svg";
export { ForwardRef as ReactComponent };